import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetNetworkMetricsTotalResData extends ApiGenericResponse {
    totalByteSent: number = 0;
    totalByteReceived: number = 0;
    dailyTotalByteSent: Array<number> = null;
    dailyTotalByteReceived: Array<number> = null;
    daysList: Array<Date> = null;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.TotalByteSent != null && obj.TotalByteSent != undefined) this.totalByteSent = obj.TotalByteSent;
        if (obj.TotalByteReceived != null && obj.TotalByteReceived != undefined) this.totalByteReceived = obj.TotalByteReceived;
        if (obj.DailyTotalByteSent) this.dailyTotalByteSent = obj.DailyTotalByteSent;
        if (obj.DailyTotalByteReceived) this.dailyTotalByteReceived = obj.DailyTotalByteReceived;
        if (obj.Days) this.daysList = obj.Days;
    }
}
